<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    :rightSticky="true"
    class="cus-bg-dialog"
    style="top:0;right:0;left:auto"
  >
    <template v-slot:title>
      <v-card-title class="headline white--text px-6 mr-5" primary-title>
        <v-btn
          disabled
          class="mb-1 mr-1 proc-button-style proc-folder drag-drawflow"
          x-small
          height="30"
          width="30"
          color="proc darken-1"
        >
          <icon-svg :size="procIconSize" iconName="proc-folder" />
        </v-btn>
        <font class="text-xl font-bold leading-snug textcolor5--text">
          Folder
        </font>
        <v-spacer></v-spacer>
        <v-btn class="btn btn-close rounded-xl" :disabled="!$auth.manage" @click="closeComDialog">{{
          $t('btn.common.close')
        }}</v-btn>
      </v-card-title>
    </template>
    <v-row v-if="this.options.item.data.systemFoldList" class="mt-0 px-6 mt-5">
      <v-col cols="12" md="9" class="pl-3 pr-0 py-0">
        <v-text-field
          solo
          v-model="this.options.item.data.dirPath"
          readonly
          class="search-button mt-0 mb-2"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="!this.options.item.data.systemFoldList" class="mt-0 px-6 mt-5">
      <v-col cols="12" md="9" class="pl-3 pr-0 py-0">
        <v-text-field
          :placeholder="$t('lbl.mapBuilder.loadFile.searchFolderPlaceHolder')"
          append-icon="fas fa-search"
          solo
          v-model="searchLeft"
          class="search-button mt-0 mb-2"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="3" class="pr-3 pl-3 py-0">
        <v-btn small text icon @click="deleteItem" class="mt-2">
          <icon-svg iconName="delete" size="24" />
        </v-btn>
        <v-btn small text icon @click="addFolder" class="mt-2">
          <icon-svg iconName="folder-add" size="24" />
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="!this.options.item.data.systemFoldList" class="tree-panel px-6" no-gutters>
      <v-row class="tree-panel" no-gutters>
        <v-col cols="12">
          <v-row class="no-gutters">
            <v-treeview
              :search="searchLeft"
              :items="treeItems"
              :item-key="'id'"
              :selection-type="'independent'"
              return-object
              ref="folderTreeView"
              v-model="tree"
              activatable
              selectable
              class="analyzedTree custom-tree file-view-wrap"
              @input="onSelectTreeItem"
              @update:active="updateActive"
            >
              <template v-slot:label="{ item, open }">
                <div
                  v-if="item.status != 'added'"
                  :class="['group-has-children-item', 'display-flex', item.id]"
                  @contextmenu.stop="showContextMenu($event, item)"
                  @dblclick="selectFolder(item)"
                >
                  <v-icon
                    small
                    v-if="open && item.children.length > 0"
                    @click.stop="openItemClick(item, false)"
                    class="mr-2"
                    >fas fa-caret-down</v-icon
                  >
                  <v-icon
                    small
                    v-if="!open && item.children.length > 0"
                    @click.stop="openItemClick(item, true)"
                    class="mr-2"
                    >fas fa-caret-right</v-icon
                  >
                  <icon-svg size="18" iconName="folder" class="mr-2" />
                  <div
                    v-if="typeContext == 'Rename' && item.id === selectedId"
                    class="group-has-children-item display-flex"
                  >
                    <v-text-field
                      :ref="'folder' + item.id"
                      v-model="item.name"
                      class="new-folder-text-field"
                      dense
                      solo
                      hide-details
                      outlined
                    >
                    </v-text-field>
                    <v-btn
                      small
                      text
                      icon
                      @click.stop="saveTreeFolderItem(item)"
                      class="ml-1 d-inline-flex"
                    >
                      <icon-svg iconName="save" size="24" />
                    </v-btn>
                    <v-btn
                      small
                      text
                      icon
                      @click.stop="cancelSaveTreeFolderItem(item)"
                      class="ml-0 d-inline-flex"
                    >
                      <icon-svg iconName="cancel" size="24" />
                    </v-btn>
                  </div>
                  <div class="folder-name" v-else>{{ item.name }}</div>
                </div>
                <div v-if="item.status == 'added'" class="group-has-children-item display-flex">
                  <v-icon small class="mr-1">fas fa-folder</v-icon>
                  <v-text-field
                    class="new-folder-text-field"
                    v-model="item.name"
                    dense
                    solo
                    hide-details
                  ></v-text-field>
                  <v-btn
                    small
                    text
                    icon
                    @click.stop="saveTreeFolderItem(item)"
                    class="ml-1 d-inline-flex"
                  >
                    <icon-svg iconName="save" size="24" />
                  </v-btn>
                  <v-btn
                    small
                    text
                    icon
                    @click.stop="cancelSaveTreeFolderItem(item)"
                    class="ml-0 d-inline-flex"
                  >
                    <icon-svg iconName="cancel" size="24" />
                  </v-btn>
                </div>
              </template>
              <template v-slot:append="{ item }">
                <div
                  v-if="item.status != 'added' && item.id == '0000000000'"
                  :class="['group-has-children-item', 'display-flex', item.id]"
                >
                  <v-btn
                    class="btn btn-load"
                    @click="expandAllTreeView($event)"
                    color="primary"
                    dark
                    ref="expandAll"
                  >
                    {{ expand }}
                  </v-btn>
                </div>
              </template>
            </v-treeview>
            <v-menu
              v-model="showMenu"
              :position-x="x"
              :position-y="y"
              absolute
              offset-y
              content-class="file-menu-context"
            >
              <v-list flat>
                <v-list-item-group>
                  <v-list-item
                    v-for="(item, i) in contexts"
                    :key="i"
                    @click="selectContextMenu(item)"
                  >
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </v-row>
        </v-col>
      </v-row>
    </v-row>

    <discardChange
      ref="confirmDialog"
      detail="Discard Changes?"
      :showCancel="true"
      color="information"
      size="max"
      title="confirmDialog"
      @select-confirm="removeDialog()"
    ></discardChange>
    <dialogWindow
      ref="deleteDialog"
      size="max"
      title="Delete Folder"
      :detail="$t('msg.common.infoConfirm.detail', ['delete the folder'])"
      color="confirmation"
      :showCancel="true"
      @select-ok="onDeleteItem()"
    ></dialogWindow>
    <dialogWindow
      ref="warningAddNewFolderDialog"
      size="max"
      title="Warning"
      :detail="warningDetail"
      color="validation"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
import $ from 'jquery';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import discardChange from '@/vue-dlb/components/DiscardChange.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { FolderTreeParser } from '@/vue-caas/utils/foldtree_parser';
import cfg from '@/vue-caas/config/config.js';
const msgtreeParser = new FolderTreeParser();
import { runSave } from '@/vue-caas/views/processnew/component/saveRunner.js';

export default {
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    manage: {
      default: false,
    },
  },
  components: {
    dialogWindow,
    DialogDrag,
    discardChange,
    IconSvg,
  },
  data() {
    return {
      procIconSize: 16,
      isHistory: false,
      nodeId: '',
      comTp: 'DIR',
      items: [],
      prs: {},
      comId: '',
      searchLeft: '',
      expand: 'Expand',
      selectTreeItems: [],
      tree: [],
      activeFolder: null,
      treeItems: [],
      leftItems: {
        header: ['USER_ID'],
        data: [
          {
            USER_ID: '',
          },
        ],
      },
      deleteFolderHeader: [],

      pathFolder: '',
      foldId: '',
      showMenu: false,
      contexts: [
        { text: this.$t('lbl.mapBuilder.loadFile.contextMenu.rename') },
        { text: this.$t('lbl.mapBuilder.loadFile.contextMenu.refresh') },
      ],
      x: 0,
      y: 0,
      typeContext: '',
      selectedId: '',
      warningDetail: '',
    };
  },
  watch: {
    foldList() {
      console.log('change', this.foldList);
      this.treeItems = msgtreeParser.parse(this.foldList);
    },
    comId() {
      setTimeout(() => {
        this.foldId = this.comId;
        this.$refs.folderTreeView.updateActive(this.comId, true);
      }, 1000);
    },
  },
  created() {
    this.initialize();
    EventBus.$on('check-right-layer-change', this.closeComDialog);
  },
  mounted() {
    setTimeout(() => {
      this.$refs.expandAll.$el.click();
    }, 1000);
    setTimeout(() => {
      console.log('Check folder tree', this.$refs.folderTreeView, this.comId);
      this.foldId = this.comId;
      if (this.$refs.folderTreeView) this.$refs.folderTreeView.updateActive(this.comId, true);
    }, 1000);
  },
  methods: {
    queryLeftList() {
      this.leftItems.data[0].USER_ID = this.$cookies.get('user-id');
      this.$store.dispatch('queryFolderList', this.leftItems).then(() => {
        let formEmit = {
          comId: this.foldId,
          nodeId: this.nodeId,
          type: this.comTp,
        };
        EventBus.$emit('refresh-list-component', formEmit);
      });
    },
    initialize() {
      this.nodeId = this.options.item.data.nodeId;
      this.comTp = this.options.item.data.comTp;
      if (this.options.item.isHistory) this.isHistory = this.options.item.isHistory;
      this.comId = this.options.item.data.comId;
      console.log('created', this.foldList);
      this.treeItems = msgtreeParser.parse(this.foldList);
      console.log('tree', this.treeItems);
      this.foldId = this.comId;
    },
    deleteItem(item) {
      this.deleteFolderHeader = [];
      let self = this;
      let check = function(value) {
        let chk = self.deleteFolderHeader.findIndex((e) => e.FOLD_ID === value);
        if (chk < 0) self.deleteFolderHeader.push({ FOLD_ID: value });
      };
      for (let i = 0; i < this.selectTreeItems.length; i++) {
        check(this.selectTreeItems[i].id);
        if (this.selectTreeItems[i].children.length > 0) {
          this.selectTreeItems[i].children.map((lv2) => {
            check(lv2.id);
            if (lv2.children.length > 0) {
              lv2.children.map((lv3) => check(lv3.id));
            }
          });
        }
      }
      if (cfg.isDlb) {
        self.$refs.deleteDialog.dialog = true;
      } else {
        this.$store
          .dispatch('getListUseInWorkflow', {
            type: 'FOLDER',
            value: '',
            listChk: this.deleteFolderHeader,
          })
          .then((res) => {
            if (res.length > 0) {
              EventBus.$emit(
                'openDelHistoryWorkflowDialog',
                res,
                this.deleteFolderHeader,
                this.nodeId
              );
            } else {
              self.$refs.deleteDialog.dialog = true;
            }
          });
      }
    },
    onDeleteItem(item) {
      let self = this;
      this.$store.dispatch('deleteWorkSpaceFolders', this.deleteFolderHeader).then(() => {
        console.log('--------- Delete Folder -----');
        this.leftItems.data[0].USER_ID = this.$cookies.get('user-id');
        this.$store.dispatch('queryFolderList', this.leftItems).then(() => {
          $('.proc-component.v-card.v-sheet').each(function() {
            let comp = $(this)[0].__vue__.$parent;
            if (comp.comTp == 'DIR') {
              self.deleteFolderHeader.forEach((item) => {
                if (item.FOLD_ID === comp.foldId) {
                  comp.resetForm();
                }
              });
            }
          });
        });
      });
    },
    onSelectTreeItem(item) {
      this.selectTreeItems = item.filter((e) => e.status != 'added');
      console.log('onSelectTreeItem: ', this.selectTreeItems);
    },
    updateActive(arr) {
      if (arr[0]) {
        this.pathFolder = arr[0].foldpath;
        this.foldId = arr[0].id;
      }
      if (arr.length == 0) {
        this.activeFolder = null;
        return;
      }
      if (arr[0].status != 'added') {
        EventBus.$emit('queryRighttList', arr[0]);
        this.activeFolder = arr[0];
      }
    },
    openItemClick(item, open) {
      this.$refs.folderTreeView.updateOpen(item.id, open);
    },
    deleteFolder() {
      if (this.selectTreeItems.length == 0) {
        this.$refs.warningDeleteFolder.dialog = true;
      } else {
        this.$refs.confirmDialog.dialog = true;
      }
    },
    addFolder() {
      if (this.activeFolder == null) {
        this.$refs.warningAddNewFolderDialog.dialog = true;
        this.warningDetail = 'Please select folder';
        return;
      }
      let selectTree = this.activeFolder;
      selectTree.children.push({
        children: [],
        id: 'test',
        parentlevel: selectTree.level,
        name: 'New Folder',
        parentid: selectTree.id,
        status: 'added',
      });
      let treeData = this.treeItems;

      setTimeout(() => {
        this.treeItems = treeData;
        this.$nextTick(() => {
          this.$refs.folderTreeView.updateOpen(this.activeFolder.id, true);
        });
      }, 300);
    },
    async saveTreeFolderItem(item) {
      const result = await runSave(this, 'DIR', { mode: 'form', data: item, subType: 'CUSTOM' });
      if (!result.success) {
        console.log(result.message);
      }
    },
    expandAllTreeView(e) {
      if (e == undefined) {
        this.$refs.folderTreeView.updateOpen('0000000000', true);
      } else {
        e.stopImmediatePropagation();
        this.openAll = !this.openAll;
        if (this.openAll) {
          this.expand = 'Collapse';
          this.$refs.folderTreeView.updateAll(this.openAll);
        } else {
          this.expand = 'Expand';
          this.$refs.folderTreeView.updateAll(this.openAll);
          this.$refs.folderTreeView.updateOpen('0000000000', true);
        }
      }
    },
    cancelSaveTreeFolderItem(item) {
      let status = item.status;
      this.selectedId = '';
      this.typeContext = '';
      if (status === 'added' && this.activeFolder) {
        this.activeFolder.children = this.activeFolder.children.slice(0, -1);
        let treeData = this.treeItems;
        setTimeout(() => {
          this.treeItems = treeData;
          this.$nextTick(() => {
            this.$refs.folderTreeView.updateOpen(this.activeFolder.id, true);
          });
        }, 300);
      }
      this.queryLeftList();
    },
    async selectContextMenu(item) {
      this.typeContext = item.text;
      if (this.typeContext === 'Rename') {
        console.log('Rename Folder: ', this.typeContext);
      } else if (this.typeContext === 'Delete') {
        console.log('Delete Folder: ', this.typeContext);
        this.deleteFolder();
      } else if (this.typeContext === 'Refresh') {
        console.log('Refresh Folder: ', this.typeContext);
        this.queryLeftList();
      }
    },
    showContextMenu(e, item) {
      e.preventDefault();
      this.selectedId = item.id;
      console.log('selected id:', this.selectedId);
      if (this.selectedId) {
        this.$refs.folderTreeView.updateActive(this.selectedId, true);
        this.showMenu = true;
        this.x = e.clientX;
        this.y = e.clientY;
      } else {
        this.showMenu = false;
        return;
      }
    },
    selectFolder(item) {
      this.foldId = item.id;
      this.pathFolder = item.foldpath;
      if (this.foldId && this.pathFolder) {
        EventBus.$emit('change-component-data', this.foldId, this.nodeId);
      }
      this.removeDialog({});
    },
    closeComDialog() {
      this.removeDialog();
    },
    removeDialog() {
      this.closeDialog(this.id);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },
  computed: {
    foldList() {
      let data = [];
      this.$store.getters.foldList.forEach((e) => {
        if (e.FOLD_PA_ID === '0000000000' && e.FOLD_NAME === 'SYSTEM_' + e.FOLD_ID) {
          // this.systemFoldList.push(e);
        } else {
          data.push(e);
        }
      });
      return data;
    },
    systemFoldList() {
      let data = [];
      this.$store.getters.foldList.forEach((e) => {
        if (e.FOLD_PA_ID === '0000000000' && e.FOLD_NAME === 'SYSTEM_' + e.FOLD_ID) {
          data.push(e);
        }
      });
      return data;
    },
  },
};
</script>
